import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice, Status } from '@app/shared/interfaces/invoice.interface';
import { Size as IconSize, Style } from '@app/shared/components/atoms/icon/icon.component';
import { Color } from '@app/shared/models/color.model';
import { ToggleSwitchSize } from '@app/shared/models/toggle-switch.model';

@Component({
  selector: 'app-toggle-switch-check',
  templateUrl: './toggle-switch-check.component.html',
  styleUrls: ['./toggle-switch-check.component.scss'],
  standalone: false,
})
export class ToggleSwitchCheckComponent {
  @Input() data!: Invoice;

  ToggleSwitchSize = ToggleSwitchSize;

  protected readonly Style = Style;

  protected readonly Status = Status;

  protected readonly Color = Color;
  protected readonly ToggleSize = ToggleSwitchSize;
  protected readonly IconSize = IconSize;

  @Input({ required: true }) id?: string;

  @Input() size: ToggleSwitchSize = ToggleSwitchSize.medium;

  @Input() disabled: boolean = false;

  @Input() selected?: string;

  @Output() selectedChange = new EventEmitter<string>();

  onToggle(key: Status) {
    const { selected } = this;
    if (selected !== key) {
      this.selectedChange.emit(key);
    }
  }

  isSelected(key: Status): boolean {
    const { selected } = this;
    return key === selected;
  }
}
